// Shared blog posts — used by BlogPage (all posts), BlogPreview on the home
// page (latest 3), and BlogDetailPage (single post by id).
// Card images live in /public/images/blog/ — replace with real photos using the same file names
const posts = [
  {
    id: 1,
    date: 'April 8, 2026', cat: 'Digital Marketing', img: '/images/blog/seo.jpg',
    title: '10 SEO Strategies Every Small Business Should Know in 2025',
    desc: 'Search engine optimization remains one of the most cost-effective ways to drive organic traffic. Here are ten proven strategies that small businesses can implement today to improve their visibility on Google.',
    content: `Search engine optimization remains one of the most cost-effective ways to drive organic traffic. Here are ten proven strategies that small businesses can implement today to improve their visibility on Google.

1. Optimize for local search by claiming and completing your Google Business Profile — accurate hours, categories, and photos make a real difference.

2. Focus on long-tail keywords that match how your customers actually search, rather than competing for broad, high-competition terms.

3. Improve your site's page speed. A slow-loading site hurts both rankings and conversions.

4. Write helpful, original content that answers real customer questions instead of thin, keyword-stuffed pages.

5. Build quality backlinks through partnerships, guest posts, and local business directories.

6. Make sure your site is mobile-friendly — most searches now happen on phones.

7. Use descriptive, keyword-rich title tags and meta descriptions for every page.

8. Add schema markup so search engines can better understand your content and show rich results.

9. Regularly audit and fix broken links, duplicate content, and crawl errors.

10. Track your rankings and traffic with tools like Google Search Console so you can double down on what's working.

Consistency matters more than any single trick — small, steady improvements compound over time and are what ultimately move the needle for local businesses.`,
  },
  {
    id: 2,
    date: 'March 25, 2026', cat: 'Web Development', img: '/images/blog/website.jpg',
    title: 'Why Your Business Needs a Professional Website in 2026',
    desc: 'In an era where first impressions are made online, having a professionally designed website is no longer optional. Discover why investing in your web presence is the smartest business decision you can make.',
    content: `In an era where first impressions are made online, having a professionally designed website is no longer optional. Discover why investing in your web presence is the smartest business decision you can make.

Your website is often the very first interaction a potential customer has with your brand — before a phone call, before a store visit, before anything else. A dated or clunky site can quietly turn people away before they even give you a chance.

A professional website builds instant credibility. It signals that you're established, trustworthy, and serious about your business, which matters just as much for a local shop as it does for a growing company.

It also works around the clock. Unlike a physical location, your website is open 24/7, answering questions, showcasing your work, and capturing leads even while you sleep.

Beyond appearances, a well-built site improves discoverability through search engines, making it easier for new customers to find you in the first place. Paired with clear calls-to-action, it turns casual visitors into paying customers.

In short, your website isn't just a digital brochure — it's one of your hardest-working sales tools, and investing in it properly pays for itself many times over.`,
  },
  {
    id: 3,
    date: 'March 15, 2026', cat: 'AI & Technology', img: '/images/blog/ai.jpg',
    title: 'How AI Is Transforming Digital Marketing for Indian Businesses',
    desc: 'Artificial intelligence is revolutionizing how businesses approach marketing. From predictive analytics to automated content creation, learn how AI tools can supercharge your marketing efforts.',
    content: `Artificial intelligence is revolutionizing how businesses approach marketing. From predictive analytics to automated content creation, learn how AI tools can supercharge your marketing efforts.

Indian businesses, from local retailers to fast-growing startups, are increasingly turning to AI-powered tools to compete with larger players — without needing a large in-house team.

Predictive analytics helps businesses understand what customers are likely to want next, allowing for smarter inventory decisions and more relevant offers.

AI-driven content tools speed up everything from writing ad copy to generating product descriptions, freeing up teams to focus on strategy instead of repetitive tasks.

Chatbots and virtual assistants now handle a large share of customer queries instantly, improving response times and customer satisfaction while reducing support costs.

Personalization engines use browsing and purchase behavior to tailor recommendations, emails, and offers to each individual customer — something that used to require large marketing budgets.

The businesses that adopt these tools early aren't just saving time; they're building a lasting competitive advantage in an increasingly digital marketplace.`,
  },
  {
    id: 4,
    date: 'March 5, 2026', cat: 'Social Media', img: '/images/blog/social-media.jpg',
    title: 'The Complete Guide to Social Media Marketing for Startups',
    desc: 'Building a social media presence from scratch can feel overwhelming. This comprehensive guide walks you through platform selection, content planning, audience building, and measuring ROI.',
    content: `Building a social media presence from scratch can feel overwhelming. This comprehensive guide walks you through platform selection, content planning, audience building, and measuring ROI.

Start by choosing the right platforms. Rather than trying to be everywhere at once, focus on the one or two channels where your target audience actually spends their time.

Plan your content around a simple mix: educate, entertain, and promote. A good rule of thumb is to keep purely promotional posts to no more than a third of what you share.

Consistency beats intensity. Posting regularly, even if it's just a few times a week, builds more trust and reach than sporadic bursts of activity.

Engage with your audience genuinely — reply to comments, join relevant conversations, and treat social media as a two-way channel rather than a broadcast.

Finally, track what matters. Vanity metrics like follower count are easy to obsess over, but engagement rate, website clicks, and conversions are what actually reflect business impact.

With a clear plan and consistent execution, even a small startup can build a social media presence that punches well above its size.`,
  },
  {
    id: 5,
    date: 'February 20, 2026', cat: 'Graphic Design', img: '/images/blog/branding.jpg',
    title: '5 Branding Mistakes That Are Costing You Customers',
    desc: "Your brand is more than a logo — it's the emotional connection people have with your business. Avoid these common branding pitfalls that silently drive potential customers away.",
    content: `Your brand is more than a logo — it's the emotional connection people have with your business. Avoid these common branding pitfalls that silently drive potential customers away.

1. Inconsistent visuals across platforms. When your logo, colors, and fonts look different on your website, social media, and packaging, it quietly erodes trust.

2. No clear brand voice. Customers should be able to recognize your tone — friendly, professional, playful — no matter where they encounter your content.

3. Copying competitors instead of standing out. Blending in might feel safe, but it makes it harder for customers to remember why they should choose you.

4. Ignoring the customer experience. Branding isn't just visuals; it's every touchpoint, from how you answer the phone to how you package a delivery.

5. Never revisiting your brand as you grow. A brand identity that made sense in your first year may no longer reflect who you've become — and holding onto it too long can hold your business back.

Fixing even one or two of these can make a noticeable difference in how customers perceive and remember your business.`,
  },
  {
    id: 6,
    date: 'February 10, 2026', cat: 'eCommerce', img: '/images/blog/ecommerce.jpg',
    title: 'eCommerce Trends Shaping Online Retail in India',
    desc: "India's eCommerce market is booming. From voice search integration to hyper-personalized shopping experiences, here are the trends that will define online retail in the coming year.",
    content: `India's eCommerce market is booming. From voice search integration to hyper-personalized shopping experiences, here are the trends that will define online retail in the coming year.

Voice commerce is on the rise as more shoppers use voice assistants to search for products and place orders, especially in regional languages.

Hyper-personalization is becoming the norm, with online stores tailoring product recommendations, pricing, and promotions to individual shopping behavior in real time.

Quick commerce continues to grow, with customers expecting delivery windows measured in minutes rather than days for everyday essentials.

Social commerce is blurring the line between social media and shopping, as more purchases happen directly through Instagram, WhatsApp, and other platforms.

Sustainability is also shaping buying decisions, with more customers favoring brands that are transparent about sourcing and packaging.

Retailers that adapt early to these shifts — rather than reacting to them later — will be best positioned to capture India's next wave of online shoppers.`,
  },
];

export default posts;
